import { FontType, TextAlign } from '@modusign/react-signing/types';

import { AbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/types';
import CompanyNameFieldPlaceholder from '@app/features/apply-react-signing/components/FieldSetupStep/Placeholders/CompanyNameFieldPlaceholder';
import { useTransformTextStyle } from '@app/features/apply-react-signing/libs/hooks/useTransFormTextStyle';
import PDFFontNormalizer from '@app/libs/reactPdfJs/utils/PDFFontNormalizer';

interface NameFieldMousePlaceholderProps {
  size: AbsoluteSize;
  fontFamily: FontType;
  fontSize: number;
  required: boolean;
  textAlign: TextAlign;
  participantOrder: number;
  scale: number;
}

const defaultProps = {
  latestFieldData: null,
  participantOrder: 1,
  scale: 1,
};

function NameFieldMousePlaceholder({
  size,
  fontFamily,
  fontSize,
  required,
  textAlign,
  participantOrder,
  scale,
}: NameFieldMousePlaceholderProps) {
  const fontPixelSize = PDFFontNormalizer.toPixelFontSize({ fontSize }, scale);
  const { transformTextStyle } = useTransformTextStyle({
    size,
    fontFamily,
    fontSize,
    textAlign,
    scale,
  });

  return (
    <CompanyNameFieldPlaceholder
      fontPixelSize={fontPixelSize}
      participantOrder={participantOrder}
      rootElementSize={size}
      star={required}
      style={transformTextStyle}
    />
  );
}

NameFieldMousePlaceholder.defaultProps = defaultProps;

export default NameFieldMousePlaceholder;
